export default __webpack_public_path__ + "static/media/metamask.dedd19ee.png";